/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Formvalidation_Required1Inputs */

const en_formvalidation_required1 = /** @type {(inputs: Formvalidation_Required1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} is required`)
};

/**
* | output |
* | --- |
* | "{name} is required" |
*
* @param {Formvalidation_Required1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formvalidation_required1 = /** @type {((inputs: Formvalidation_Required1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formvalidation_Required1Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formvalidation_required1(inputs)
});
export { formvalidation_required1 as "formValidation_required" }